import React from "react";
import PropTypes from "prop-types";

import { LOGIN, PROJECT_LOGIN, REGISTER, PROJECT_REGISTER } from "App/Routes";
import LoginDescriptionRow from "./LoginDescriptionRow";
import LoginImageRow from "./LoginImageRow";
import LoginPoweredByImageRow from "./LoginPoweredByImageRow";
import LoginHomePage from "components/Login/LoginHomePage";
import Link from "components/shared/Link/Link";

import { USE_LOGIN_HOME_TEMPLATE_1, ENABLE_REGISTER_PAGES } from "config";
import localize from "lang/localize";

const propTypes = {
  projectId: PropTypes.number,
  language: PropTypes.string,
  /* Guest Login Dialog */
  guestEnabled: PropTypes.bool.isRequired,
  showGuestLoginDialog: PropTypes.bool.isRequired,
  handleOpenGuestLoginDialog: PropTypes.func.isRequired,
  handleCloseGuestLoginDialog: PropTypes.func.isRequired,
  /* OAuth */
  responseFacebook: PropTypes.func.isRequired,
  responseFacebookError: PropTypes.func.isRequired,
  responseGoogle: PropTypes.func.isRequired,
  responseGoogleError: PropTypes.func.isRequired,
  /* Custom: Project description */
  projectDescription: PropTypes.string
};

class GourmetGrammarLoginHomePage extends LoginHomePage {
  /* Custom: <h5> for title */
  renderRegisterSection() {
    if (ENABLE_REGISTER_PAGES) {
      return (
        <div className="topmargin-30">
          <h5 className="textcenter nomargin">
            <strong>
              {localize("login_view_register_start", this.props.language) + " "}
            </strong>
          </h5>
          <p className="textcenter">
            <Link
              to={
                this.props.projectId
                  ? PROJECT_REGISTER.format(this.props.projectId)
                  : REGISTER
              }
              className="default"
            >
              {localize("login_view_signup_text", this.props.language)}
            </Link>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  /* Custom: reusable divider */
  renderLoginDivider() {
    return (
      <div className="login-divider hide-below-md topmargin-30 bottommargin-30" />
    );
  }

  render() {
    if (USE_LOGIN_HOME_TEMPLATE_1) {
      return (
        <div className="login-register-container container verticalpadding">
          <div className="innerblock pure-g">
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2 login-panel">
              <div className="pure-g topmargin-20">
                <Link
                  className="button fullwidth cta"
                  to={
                    this.props.projectId
                      ? PROJECT_LOGIN.format(this.props.projectId)
                      : LOGIN
                  }
                >
                  {localize("button_login_email", this.props.language)}
                </Link>
              </div>
              {this.renderUseSSOButtonContainer()}
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      /* Custom: Gourmet Grammar Layout using Login Home Template 2 */
      return (
        <div className="login-register-container container verticalpadding flex-from-md">
          <div className="innerblock flex-from-md align-items-center">
            <div className="pure-u-1-1 pure-u-md-11-24 horizontalpadding-5">
              <div className="pure-g">
                <div className="hide-from-md">
                  <LoginImageRow />
                </div>
                <h2 className="welcome-to-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_login_view_welcome_text",
                    this.props.language
                  )}
                </h2>
                <h2 className="gourmet-grammar-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_gourmet_grammar_text",
                    this.props.language
                  )}
                </h2>
                <LoginDescriptionRow
                  projectDescription={this.props.projectDescription}
                />
              </div>
              <div>
                <div className="pure-u-1-12 pure-u-md-1-1" />
                <div className="pure-u-5-6 pure-u-md-1-1">
                  <Link
                    className="button fullwidth cta"
                    to={
                      this.props.projectId
                        ? PROJECT_LOGIN.format(this.props.projectId)
                        : LOGIN
                    }
                  >
                    {localize("button_login_email", this.props.language)}
                  </Link>
                  {this.renderGuestLoginSection()}
                  {this.renderSSOLoginSection()}
                </div>
                <div className="pure-u-1-12 pure-u-md-1-1" />
              </div>
              {this.renderLoginDivider()}
              {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
            </div>
            <div className="pure-u-1-1 pure-u-md-1-12 hide-below-md" />
            <div className="pure-u-1-1 pure-u-md-11-24 horizontalpadding-5 hide-below-md">
              <div className="hide-below-md">
                <LoginImageRow />
                <LoginPoweredByImageRow />
              </div>
            </div>
          </div>
          <div className="hide-from-md topmargin-10">
            <LoginPoweredByImageRow />
          </div>
        </div>
      );
    }
  }
}

GourmetGrammarLoginHomePage.propTypes = propTypes;

export default GourmetGrammarLoginHomePage;
